module.exports = __webpack_public_path__ + "img/ddd.92caa9f2.svg";